import React, { useState } from "react"
import { graphql } from "gatsby"
import Layout from "./../components/layout"
import Blogcards from "../components/blogs/Blogcards"
import BackgroundImage from "gatsby-background-image"
import DSA from "../components/categories/DSA"

function BlogContainer({ data }) {
  const [show, setShow] = useState(false)
  const container = data.container
  const blogs = data.blogs.edges
  const bgImg = data.bgImg
  const totalCount = data.posts.totalCount
  return (
    <Layout>
      <BackgroundImage
        fluid={bgImg.childImageSharp.fluid}
        className="blogContainer"
      >
        <div className="container-fluid pt-5">
          <div className="row">
            <div className="col-12 text-center mt-5">
              <h1 className="text-danger pt-4">
                {container.frontmatter.title}
              </h1>
              {container.excerpt && (
                <span>
                  <small>
                    <strong className="text-info">{container.excerpt}</strong>
                  </small>
                </span>
              )}
              <p className="noOfPosts">
                {totalCount} {totalCount === 1 ? "post" : "posts"}
              </p>
            </div>
            <div className="col-12 mt-2 justify-content-center">
              {container.frontmatter.slug === "dsa" && (
                <>
                  <div className="text-center">
                    <button
                      className="btn btn-sm btn-dark"
                      onClick={() => setShow(prev => !prev)}
                    >
                      Display by topics
                    </button>
                  </div>
                  <DSA show={show} />
                </>
              )}
            </div>
            <div className="col-md-10 mx-auto">
              <div className="row my-5 text-center">
                {blogs.length &&
                  blogs.map(({ node }) => (
                    <Blogcards
                      key={node.id}
                      title={node.frontmatter.title}
                      blog={node.frontmatter.blog}
                      date={node.frontmatter.date}
                      thumbnail={node.frontmatter.thumbnail}
                    />
                  ))}
              </div>
            </div>
          </div>
        </div>
      </BackgroundImage>
    </Layout>
  )
}

export default BlogContainer

export const containerQuery = graphql`
  query Container($slug: String!) {
    container: markdownRemark(
      frontmatter: { slug: { eq: $slug }, type: { eq: "category" } }
    ) {
      frontmatter {
        title
        slug
      }
      excerpt
    }
    blogs: allMarkdownRemark(
      filter: { frontmatter: { type: { eq: "blog" }, category: { eq: $slug } } }
      sort: { fields: frontmatter___thumbnail, order: DESC }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            blog
            date
            thumbnail
          }
        }
      }
    }
    bgImg: file(relativePath: { eq: "bg/bg2.jpg" }) {
      id
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    posts: allMarkdownRemark(
      filter: { frontmatter: { category: { eq: $slug }, type: { eq: "blog" } } }
    ) {
      totalCount
    }
  }
`
